const Settings = () => {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-neutral-900">Settings</h1>
        <p className="text-neutral-600 mt-1">
          Manage your account and organization settings.
        </p>
      </div>

      <div className="card">
        <p className="text-neutral-600">Settings page coming soon...</p>
      </div>
    </div>
  );
};

export default Settings;
